import {ChangeDetectionStrategy, Component, DestroyRef, Injectable, Input, signal} from "@angular/core";
import {KommentarModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Observable} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {Forelder, KommentarDatatjeneste} from "felles-ng2/tjenester/datalager/KommentarDatatjeneste";
import {antallKommentarerOgSvar} from "felles-ng2/modell/kommentarModellHjelpere";

const debug = initDebugger('KommentarerTellerKomponent');

@Component({
    selector: 'kommentarer-teller',
    template: '{{antall()}}',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KommentarerTellerKomponent {
    static ajsSelector = 'kommentarerTeller';

    antall = signal<number>(0);

    constructor(private avhengigheter: KommentarerTellerKomponentAvhengigheter, private destroyRef: DestroyRef) {
    }

    //kan ikke bruker signal da vi gjør asynk kall
    @Input({required: true}) set forelder(forelder: Forelder) {
        if (erNil(forelder)) {
            this.antall.set(0);
            return;
        }
        this.avhengigheter.kommentarer(forelder)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(kommentarer => this.antall.set(antallKommentarerOgSvar(kommentarer)));
    }

    //private hjelpemetoder
}

@Injectable()
export class KommentarerTellerKomponentAvhengigheter {

    constructor(private kommentarDatatjeneste: KommentarDatatjeneste) {
    }

    kommentarer(forelder: Forelder): Observable<KommentarModell[]> {
        return this.kommentarDatatjeneste.finnTilknyttetFraLokallager(forelder);
    }
}
